function priorityByRule(rule, property) {
  return rule.style?.getPropertyPriority(property) === "important" ? 100000 : 0;
}
export { priorityByRule };